<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.renouvellement.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('ajoutEditContrat.renouvellement.contrat.reconductible')"
            custom-class="mgb-14px">
            <qd-checkbox v-model="contrat.reconductible">
              <p class="has-text-icon-more">
                {{ $t('ajoutEditContrat.renouvellement.contrat.reconductible') }}
              </p>
            </qd-checkbox>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('ajoutEditContrat.renouvellement.contrat.tacite')"
            custom-class="mgb-14px">
            <qd-checkbox v-model="contrat.tacite">
              <p class="has-text-icon-more">
                {{ $t('ajoutEditContrat.renouvellement.contrat.tacite') }}
              </p>
            </qd-checkbox>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('ajoutEditContrat.renouvellement.contrat.etatRenouvellement')"
            custom-class="mgb-14px">
            <b-select v-model="contrat.etatRenouvellement" expanded
              @input="onSelect($event)">
              <option
                v-for="etat in constantes.LISTE_ETAT_RENOUVELLEMENT"
                :key="etat.code"
                :value="etat.code">
                {{ $t(getEtatRenouvellementLibelle(etat.code)) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12" v-if="isEtatNonRenovellement">
          <b-field :label="$t('ajoutEditContrat.renouvellement.contrat.motifNonRenouvellement')"
            custom-class="mgb-14px">
            <b-input v-model="contrat.motifNonRenouvellement" type="textarea" rows="4">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LISTE_ETAT_RENOUVELLEMENT, ETAT_NONRENOUVELEE } from '@/configuration/devisConf';

export default {
  name: 'BauxContratEditContrat',
  props: {
    contrat: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      constantes: {
        LISTE_ETAT_RENOUVELLEMENT,
        ETAT_NONRENOUVELEE,
      },
    };
  },
  computed: {
    isEtatNonRenovellement() {
      return this.contrat.etatRenouvellement === this.constantes.ETAT_NONRENOUVELEE;
    },
  },
  methods: {
    getEtatRenouvellementLibelle(code) {
      const codeLibelle = this.constantes.LISTE_ETAT_RENOUVELLEMENT.find(etatRenouvellement => {
        return etatRenouvellement.code === code;
      });
      return codeLibelle?.libelle;
    },
    onSelect(etatRenouvellement) {
      if (etatRenouvellement === this.constantes.ETAT_NONRENOUVELEE) {
        this.contrat.motifNonRenouvellement = '';
      }
    },
  },
};
</script>

<style scoped>

</style>
